<template>
  <div>
    <a-modal title="添加消息模板" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <div style="margin-bottom: 10px">
        <a-radio-group :default-value="this.radioValue" @change="radioChange" v-if="this.modifyMsgValue == ''">
          <a-radio :value="1"> 文字内容 </a-radio>
          <a-radio :value="2"> 短信参数 </a-radio>
        </a-radio-group>
      </div>
      <div v-if="this.radioValue == 1 || this.modifyMsgValue != ''">
        <a-textarea placeholder="要添加的文字" :allowClear="true" :rows="4" :maxLength="70" v-model="textValue" />
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      textValue: '', //文本框内容
      radioValue: 1, //初始单选
      textParameter: '{参数}',
      addOrModify: true, //判断是修改（true）or新增(false)
    }
  },
  props: {
    modifyMsgValue: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleOk(e) {
      if (this.textValue == ''&&this.radioValue == 1) {
        this.$message.error('文本不能为空')
      } else {
        if (this.modifyMsgValue == '') {
          if (this.radioValue == 1) {
            this.$emit('msgValue', this.textValue, this.radioValue)
            this.visible = false
          } else if (this.radioValue == 2) {
            this.$emit('msgValue', this.textParameter, this.radioValue)
            this.visible = false
          }
        } else {
          this.$emit('msgValue', this.textValue, 1, this.addOrModify)
          this.visible = false
        }
      }
    },
    handleCancel() {
      this.visible = false
    },
    //单选框
    radioChange(e) {
      this.radioValue = e.target.value
    },
    //新增
    add() {
      this.visible = true
      if (this.textValue !== '') {
        this.textValue = ''
      }
    },
    //修改
    show() {
      if (this.textValue !== '') {
        this.textValue = this.modifyMsgValue
      }
      this.visible = true
    },
  },
  watch: {
    modifyMsgValue: function (val) {
      if (this.modifyMsgValue) {
        this.textValue = this.modifyMsgValue
      }
    },
  },
}
</script>
<style lang="less" scoped>
</style>
